export default __webpack_public_path__ + "static/media/virginia.7fa209f9.png";